import { Grid2, MenuItem, TextField, Typography } from "@mui/material";
import { TextFieldStyles } from "../../../styles/commonStyles";
import { useEffect, useState } from "react";
import { Controller, useWatch } from "react-hook-form";

const PairingToolForm = ({
  fields,
  tool,
  onFormDataChange,
  control,
  errors,
  clearErrors,
}) => {
  const [field, setField] = useState("");

  const isSensor = tool === "sensor";

  const watchedValues = useWatch({
    control,
    name: ["nickname"],
  });
  const handleFieldChange = (e) => {
    setField(e.target.value);
    clearErrors?.("field");
  };

  useEffect(() => {
    const [nickname] = watchedValues;
    const selectedField = field ? fields?.find((f) => f.id === field) : "";
    const formData = {
      nickname: nickname || "",
      field_id: selectedField.id || "",
      field_name: selectedField.name || "",
      field_position: "",
    };

    if (onFormDataChange) {
      onFormDataChange(formData);
    }
  }, [field, onFormDataChange, watchedValues, fields]);

  useEffect(() => {
    setField("");
  }, [tool]);

  return (
    <>
      <Typography fontWeight="bold" fontSize="14px">
        {`Associa il ${isSensor ? "sensore" : "gateway"} a un terreno`}
      </Typography>
      <Grid2 container spacing={2}>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <Controller
            name="nickname"
            control={control}
            rules={{ required: "Inserisci un nickname" }}
            render={({ field }) => (
              <TextField
                {...field}
                variant="filled"
                fullWidth
                sx={{ ...TextFieldStyles }}
                label={`Nickname ${isSensor ? "sensore" : "gateway"}`}
                value={watchedValues.name}
                error={!!errors.nickname}
                helperText={errors.nickname?.message}
              />
            )}
          />
        </Grid2>
        <Grid2 size={{ xs: 12, md: 6 }}>
          <TextField
            variant="filled"
            fullWidth
            sx={{ ...TextFieldStyles }}
            label="Terreno"
            select
            value={field}
            onChange={handleFieldChange}
            error={!!errors.field}
            helperText={errors.field?.message}
          >
            {fields && fields.length > 0 ? (
              fields.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))
            ) : (
              <MenuItem value="">Nessun terreno disponibile</MenuItem>
            )}
          </TextField>
        </Grid2>
      </Grid2>
    </>
  );
};

export default PairingToolForm;
